var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "floating-dropup-box" }, [
    _c(
      "div",
      { staticClass: "dropup floating-dropup", class: { show: _vm.visible } },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary rounded-circle menu-toggle",
            on: { click: _vm.toggleMenu }
          },
          [
            _c(
              "i",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visible,
                    expression: "visible"
                  }
                ],
                staticClass: "material-icons"
              },
              [_vm._v("close")]
            ),
            _vm._v(" "),
            _c(
              "i",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.visible,
                    expression: "!visible"
                  }
                ],
                staticClass: "material-icons"
              },
              [_vm._v("add")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dropdown-menu dropdown-menu-right" },
          [_vm._t("default")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dde28c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dde28c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FloatingDropup.vue
// module id = luS1
// module chunks = 1